const initialState = {
  editingLocation: {},
};

const Location = (state = initialState, action) => {
  switch (action.type) {
    case "EDIT_LOCATION":
      return {
        ...state,
        editingLocation: action.data,
      };

    default:
      return state;
  }
};
export default Location;
